import React  , { Component } from 'react'

import {  HomeSlider,
          HomeTitle,
          Img       } from '../../Components/UI/UI'

import {getWeather} from '../../Utility/Utility'

import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'

import "./CoronaVirus.css"

class CoronaVirus extends Component {

  state = {
   
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,

  }

  componentDidMount () {

    getWeather((Weather)=>{
      
      console.log("Weather", Weather);
      this.setState({
        telAvivWeather : Weather.telAvivWeather,
        waterTemp : Weather.water_temp,
        jerusalemWeather : Weather.jerusalemWeather,
      })

      
    });
    

     
  }
  
  render(){
    return(
      <div className="page align-left page-Corona-virus">
        <Menu />
          <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />
            
            <div className="container">
             
        
            <p>Během tohoto náročného období stojíme v Izraeli při vás, Češi. Nabízíme naše modlitby a podporu, sjednoceni v naději s vidinou lepších zítřků.</p>
               

             {/*<h1>UPOZORNĚNÍ NA CESTY DO IZRAELE A BEZPEČNOSTNÍ INFORMACE</h1>*/}

            {/* <h2 className="ac-pink ac-margin-top-1 ac-bigger">UPOZORNĚNÍ NA CESTY DO IZRAELE A BEZPEČNOSTNÍ INFORMACE</h2>*/}
             
             <h2 className="ac-pink">NEJNOVĚJŠÍ INFORMACE O IZRAELI PRO TURISTY OHLEDNĚ KORONAVIRU (COVID-19) :</h2>
             
             {/* <p className="ac-pink">Izrael oznámil uvolnění dalších opatření</p>
             
             <p>Izraelské ministerstvo zdravotnictví oznámilo 1. června další vlnu rozvolňování opatření, mezi něž patří otevření restaurací, turistických atrakcí a hotelů.</p>
             
             <p>Pláže jsou zpřístupněny od 20. května.</p>

             <p>Od 27. května 2020 mohou být restaurace, bary, hospody a kluby otevřeny za určitých podmínek. Volnočasové a turistické atrakce, jako jsou hotely, muzea či koupaliště se při dodržování určitých podmínek také mohou otevřit.</p>
             
             <p>Ministerstvo zdravotnictví také schválilo navýšení kapacity cestujících v autobusech a taxi a obnovení činnost vlaků od 8. června.</p>
             
             <p>Zábavní a volnočasové aktivity budou znovu povoleny od 14. června včetně míst pro pořádání akcí a zahrad, koncertů, divadel, kin, uměleckých a kulturních akcí a to pod podmínkou dodržování určitých omezení.</p>
             
             <p>V oblasti cestovního ruchu oznámilo několik zemí otevření hranic izraelským občanům: Řecko, Rakousko, Černá Hora, Gruzie a nyní Kypr (počínaje 9. červnem).</p>
             
             <p>Mezinárodní letecké společnosti jako Delta Airlines, British Airways, Air Canada, Wizz Air, Ryanair, Lufthansa, Turkish Airlines, Alitalia, Ukrainian International a další oznámily, že letos v léte plánují obnovit své komerční lety do a z Izraele.</p>*/}
             
             <h2 className="ac-pink ac-margin-top-1 ac-bigger">Turisté zajímající se o cestu do Izraele:</h2>
             
             <p>V současnosti je až do odvolání vstup cizinců do Izraele z jakékoliv země zakázán. Ve výjimečných případech si lidé mohou zažádat u Ministerstva zahraničí o povolení potvrzující, že daná osoba má na místě zajištěny podmínky pro čtrnáctidenní karanténu.</p>

             <h2 className="ac-pink ac-margin-top-1 ac-bigger">Obecné pokyny pro všechny pobývající v Izraeli:</h2>

            <ul>
              <li>
                Nejnovejší informace ohledně případů nakažených koronavirem jsou dostupné na webových stránkách Ministerstva zdravotnictví.
              </li>
              <li>
                Izraelská vláda pozorně sleduje vývoj nákazy a přijala dočasná opatření včetně uzavření hranic pro cizince z celého světa.
              </li>
              <li>Lidé vykazující příznaky nesmí doprovázet pacienty nebo navštívit zařízení pro seniory.</li>
            </ul>

            <h2 className="ac-pink ac-margin-top-1 ac-bigger">Důležité!</h2>

            <ul>
              <li>
                Pokud jste museli nastoupit do karantény, 
                <strong className="ac-pink">je vaší povinností toto nahlásit na Ministerstvo zdravotnictví: <a href="https://www.govforms.gov.il" target="_blank">www.govforms.gov.il/</a></strong>
              </li>
              <li>
                Pokud máte horečku 38 °C a více, kašel , potíže s dýcháním či jiné respirační příznaky, 
                <strong className="ac-pink">musíte okamžite nastoupit do karantény a zavolat 101 MDA linku pohotovostních služeb pro zdravotnickou konzultaci.</strong>
              </li>
              <li><strong className="ac-pink">Platí absolutní zákaz vstupu do nemocnic a klinik v případě, že vykazujete jakékoliv z výše zmíněných příznaků!</strong></li>
            </ul>

            <h2 className="ac-pink ac-margin-top-1 ac-bigger">Často kladené otázky</h2>


            <ol className="ac-padding-start-0">
              <li>
                <strong className="ac-pink">Jsem turista v Izraeli a mám obavu, že můžu být nakažen COVID-19. Na koho se mohu obrátit?</strong><br/>
                Pokud máte horečku 38 °C a vice, kašel, potíže s dýcháním či jiné respirační příznaky, musíte okamžitě nastoupit do karantény a zavolat na linku 101 MDA pohotovostní zdravotnické služby. <strong class="ac-pink">Nechoďte do zdravotnického zařízení nebo pohotovost.</strong>
              </li>
              <li>
                <strong className="ac-pink">Kdy bude Izrael znovu přístupný pro turisty?</strong><br/>
                V současné době není znám termín, kdy bude Izrael přístupný pro turisty.
              </li>
            </ol>

          <Img desktopImg={"infection.jpg"} />

          </div>

          
        <Footer />
      </div>
    )
    }

}



export default CoronaVirus


// WEBPACK FOOTER //
// ./src/Pages/CoronaVirusPage/CoronaVirusCZ.js